import { createSvgComponent } from "../../icon/createSvgComponent";
import SnackbarCircle from "@core/__generated__/icon/figma/Snackbar/circle.svg";
export default createSvgComponent(SnackbarCircle);